import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetPresignedUploadURLForTranslationsRPC } from "./getPresignedUploadUrlForTranslationsRPC";

export class GetPresignedUploadURLForTranslationsRPCClientImpl extends GetPresignedUploadURLForTranslationsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetPresignedUploadURLForTranslationsRPC.Request): Promise<LeoRPCResult<GetPresignedUploadURLForTranslationsRPC.Response, GetPresignedUploadURLForTranslationsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey/GetPresignedUploadURLForTranslations",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetPresignedUploadURLForTranslationsRPC.ResponseDTO,
      GetPresignedUploadURLForTranslationsRPC.Errors.ErrorsDTO,
      GetPresignedUploadURLForTranslationsRPC.Response,
      GetPresignedUploadURLForTranslationsRPC.Errors.Errors
    >(
      response,
      "survey/GetPresignedUploadURLForTranslations",
      GetPresignedUploadURLForTranslationsRPC.Response.fromDTO,
      GetPresignedUploadURLForTranslationsRPC.Errors.fromDTO
    );
  }
}
